module.exports = __webpack_public_path__ + "img/card-bg.ea301714.png";